import React, { useState, useEffect } from "react";
import { Box, Button, Snackbar, Alert } from "@mui/material";
import EmpTable from "./EmpTable";
import EastIcon from "@mui/icons-material/East";
import AddIcon from "@mui/icons-material/Add";
import { api, get, put } from "../../../utils/api";
import { useParams } from "react-router-dom";
import { brsrReview, reviewBRSR } from "../../../utils/companyId";
import ReviewBox from "../../Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";
import style from "../../../styles/brsr/general.module.css";
import BRSRFile from "../../Common/BRSRFile";
import UploadFileBrsr from "../../Common/UploadFileBrsr";
import FetchFilesBrsr from "../../Common/FetchFilesBrsr";

const Employees = ({
  onSave,
  hide = false,
  removeUpload = false,
  downloadMode = false,
}) => {
  const { id } = useParams();

  const [currentyear, setNewDate] = useState();
  const [errors, setErrors] = useState({});
  const [modalupload, setModalUpload] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [progress, setUploadProgress] = useState([]);
  const [open, setOpen] = useState(false);
  const [errorsindex, setErrorsIndex] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [disabled, setDisabled] = useState(false);

  const [formValues, setFormValues] = React.useState({
    emp: {
      permanent: {
        total: "",
        male: "",
        female: "",
        malepercentage: "",
        femalepercentage: "",
      },
      other: {
        total: "",
        male: "",
        female: "",
        malepercentage: "",
        femalepercentage: "",
      },
      total: {
        total: "",
        male: "",
        female: "",
        malepercentage: "",
        femalepercentage: "",
      },
    },
    worker: {
      permanent: {
        total: "",
        male: "",
        female: "",
        malepercentage: "",
        femalepercentage: "",
      },
      other: {
        total: "",
        male: "",
        female: "",
        malepercentage: "",
        femalepercentage: "",
      },
      total: {
        total: "",
        male: "",
        female: "",
        malepercentage: "",
        femalepercentage: "",
      },
    },

    differentlyabled: {
      employees: {
        permanent: {
          total: "",
          male: "",
          female: "",
          malepercentage: "",
          femalepercentage: "",
        },
        other: {
          total: "",
          male: "",
          female: "",
          malepercentage: "",
          femalepercentage: "",
        },
        total: {
          total: "",
          male: "",
          female: "",
          malepercentage: "",
          femalepercentage: "",
        },
      },
      workers: {
        permanent: {
          total: "",
          male: "",
          female: "",
          malepercentage: "",
          femalepercentage: "",
        },
        other: {
          total: "",
          male: "",
          female: "",
          malepercentage: "",
          femalepercentage: "",
        },
        total: {
          total: "",
          male: "",
          female: "",
          malePercentage: "",
          femalePercentage: "",
        },
      },
    },
    womenRepresentation: {
      boardOfDirectors: {
        total: "",
        female: "",
        femalepercentage: "",
      },
      keyManagementPersonnel: {
        total: "",
        female: "",
        femalepercentage: "",
      },
    },
    // turnoverrateCurrentfyEmployeesMale
    turnoverRate: {
      currentfy: {
        employees: {
          male: "",
          female: "",
          total: "",
        },
        workers: {
          male: "",
          female: "",
          total: "",
        },
      },
      previousfy: {
        employees: { male: "", female: "", total: "" },
        workers: { male: "", female: "", total: "" },
      },
      priorfy: {
        employees: { male: "", female: "", total: "" },
        workers: { male: "", female: "", total: "" },
      },
    },
    turnoverRateDoc: [],
    womenRepresentationDoc: [],
    empAndworkerandifferentlyabledDoc: [],
  });

  useEffect(() => {
    const year = new Date().getFullYear();
    setNewDate(year);
  }, []);

  const handleUploadDocument = (e, key) => {
    setModalUpload(true);
    setOpen(true);
  };

  const validateFields = (obj, errorsindex) => {
    let errorObj = {}; // ✅ Start fresh to keep only unresolved errors

    Object.keys(errorsindex).forEach((errorKey) => {
      const nestedKeys = errorKey.split(".");
      const lastKey = nestedKeys[nestedKeys.length - 1]; // ✅ Extract last key
      const mainKey = nestedKeys[0]; // ✅ Always the first key
      const subKey =
        nestedKeys.length > 2
          ? nestedKeys.slice(1, -1).join(".")
          : nestedKeys[1] || ""; // ✅ Correctly get subKey (handles deeper nesting)

      // ✅ Traverse `obj` dynamically to check the field's value
      let fieldValue = obj;
      for (const key of nestedKeys) {
        if (fieldValue && typeof fieldValue === "object" && key in fieldValue) {
          fieldValue = fieldValue[key];
        } else {
          fieldValue = undefined;
          break;
        }
      }

      // ✅ If the field has a valid value, we do NOT add it to `errorObj`
      if (
        fieldValue !== undefined &&
        fieldValue !== "" &&
        fieldValue !== null
      ) {
        return;
      }

      // ✅ If the field is still empty, add it to `errorObj`
      if (!errorObj[mainKey]) {
        errorObj[mainKey] = [];
      }
      errorObj[mainKey].push({
        subkey: subKey,
        fieldName: lastKey,
        rowIndex: errorsindex[errorKey]?.rowIndex || "-",
        message: "This field is required",
      });
    });

    setErrors(errorObj); // ✅ Only updates with unresolved errors
    return Object.keys(errorObj).length > 0 ? errorObj : false;
  };

  useEffect(() => {}, [errors]);

  const fetchData = async () => {
    await get(`${api}/brsr/get?type=SectionA&id=${id}`)
      .then((res) => {
        const employees = res?.data?.data?.BRSRSectionA?.employeesAndWorkers;
        if (
          res?.data?.data?.year
            ? res?.data?.data?.year < currentYear - 1
            : false || !brsrReview
        )
          setDisabled(true);

        setFormValues({
          emp: {
            permanent: {
              total: employees.emp.permanent.total ?? "",
              male: employees.emp.permanent.male ?? "",
              female: employees.emp.permanent.female ?? "",
              malepercentage: employees.emp.permanent.malepercentage ?? "",
              femalepercentage: employees.emp.permanent.femalepercentage ?? "",
            },
            other: {
              total: employees.emp.other.total ?? "",
              male: employees.emp.other.male ?? "",
              female: employees.emp.other.female ?? "",
              malepercentage: employees.emp.other.malepercentage ?? "",
              femalepercentage: employees.emp.other.femalepercentage ?? "",
            },
            total: {
              total: employees.emp.total.total ?? "",
              male: employees.emp.total.male ?? "",
              female: employees.emp.total.female ?? "",
              malepercentage: employees.emp.total.malepercentage ?? "",
              femalepercentage: employees.emp.total.femalepercentage ?? "",
            },
          },
          worker: {
            permanent: {
              total: employees?.worker?.permanent?.total ?? "",
              male: employees?.worker?.permanent?.male ?? "",
              female: employees?.worker?.permanent?.female ?? "",
              malepercentage:
                employees?.worker?.permanent?.malepercentage ?? "",
              femalepercentage:
                employees?.worker?.permanent?.femalepercentage ?? "",
            },
            other: {
              total: employees?.worker?.other?.total ?? "",
              male: employees?.worker?.other?.male ?? "",
              female: employees?.worker?.other?.female ?? "",
              malepercentage: employees?.worker?.other?.malepercentage ?? "",
              femalepercentage:
                employees?.worker?.other?.femalepercentage ?? "",
            },
            total: {
              total: employees?.worker?.total?.total ?? "",
              male: employees?.worker?.total?.male ?? "",
              female: employees?.worker?.total?.female ?? "",
              malepercentage: employees?.worker?.total?.malepercentage ?? "",
              femalepercentage:
                employees?.worker?.total?.femalepercentage ?? "",
            },
          },

          differentlyabled: {
            employees: {
              permanent: {
                total:
                  employees?.differentlyabled?.employees?.permanent?.total ??
                  "",
                male:
                  employees?.differentlyabled?.employees?.permanent?.male ?? "",
                female:
                  employees?.differentlyabled?.employees?.permanent?.female ??
                  "",
                malepercentage:
                  employees?.differentlyabled?.employees?.permanent
                    ?.malepercentage ?? "",
                femalepercentage:
                  employees?.differentlyabled?.employees?.permanent
                    ?.femalepercentage ?? "",
              },
              other: {
                total:
                  employees?.differentlyabled?.employees?.other?.total ?? "",
                male: employees?.differentlyabled?.employees?.other?.male ?? "",
                female:
                  employees?.differentlyabled?.employees?.other?.female ?? "",
                malepercentage:
                  employees?.differentlyabled?.employees?.other
                    ?.malepercentage ?? "",
                femalepercentage:
                  employees?.differentlyabled?.employees?.other
                    ?.femalepercentage ?? "",
              },
              total: {
                total:
                  employees?.differentlyabled?.employees?.total?.total ?? "",
                male: employees?.differentlyabled?.employees?.total?.male ?? "",
                female:
                  employees?.differentlyabled?.employees?.total?.female ?? "",
                malepercentage:
                  employees?.differentlyabled?.employees?.total
                    ?.malepercentage ?? "",
                femalepercentage:
                  employees?.differentlyabled?.employees?.total
                    ?.femalepercentage ?? "",
              },
            },
            workers: {
              permanent: {
                total:
                  employees?.differentlyabled?.workers?.permanent?.total ?? "",
                male:
                  employees?.differentlyabled?.workers?.permanent?.male ?? "",
                female:
                  employees?.differentlyabled?.workers?.permanent?.female ?? "",
                malepercentage:
                  employees?.differentlyabled?.workers?.permanent
                    ?.malepercentage ?? "",
                femalepercentage:
                  employees?.differentlyabled?.workers?.permanent
                    ?.femalepercentage ?? "",
              },
              other: {
                total: employees?.differentlyabled?.workers?.other?.total ?? "",
                male: employees?.differentlyabled?.workers?.other?.male ?? "",
                female:
                  employees?.differentlyabled?.workers?.other?.female ?? "",
                malepercentage:
                  employees?.differentlyabled?.workers?.other?.malepercentage ??
                  "",
                femalepercentage:
                  employees?.differentlyabled?.workers?.other
                    ?.femalepercentage ?? "",
              },
              total: {
                total: employees?.differentlyabled?.workers?.total?.total ?? "",
                male: employees?.differentlyabled?.workers?.total?.male ?? "",
                female:
                  employees?.differentlyabled?.workers?.total?.female ?? "",
                malepercentage:
                  employees?.differentlyabled?.workers?.total?.malepercentage ??
                  "",
                femalepercentage:
                  employees?.differentlyabled?.workers?.total
                    ?.femalepercentage ?? "",
              },
            },
          },
          womenRepresentation: {
            boardOfDirectors: {
              total:
                employees?.womenRepresentation?.boardOfDirectors?.total ?? "",
              female:
                employees?.womenRepresentation?.boardOfDirectors?.female ?? "",
              femalepercentage:
                employees?.womenRepresentation?.boardOfDirectors
                  ?.femalepercentage ?? "",
            },
            keyManagementPersonnel: {
              total:
                employees?.womenRepresentation?.keyManagementPersonnel?.total ??
                "",
              female:
                employees?.womenRepresentation?.keyManagementPersonnel
                  ?.female ?? "",
              femalepercentage:
                employees?.womenRepresentation?.keyManagementPersonnel
                  ?.femalepercentage ?? "",
            },
          },
          // turnoverrateCurrentfyEmployeesMale
          turnoverRate: {
            currentfy: {
              employees: {
                male: employees?.turnoverRate?.currentfy?.employees?.male ?? "",
                female:
                  employees?.turnoverRate?.currentfy?.employees?.female ?? "",
                total:
                  employees?.turnoverRate?.currentfy?.employees?.total ?? "",
              },
              workers: {
                male: employees?.turnoverRate?.currentfy?.workers?.male ?? "",
                female:
                  employees?.turnoverRate?.currentfy?.workers?.female ?? "",
                total: employees?.turnoverRate?.currentfy?.workers?.total ?? "",
              },
            },
            previousfy: {
              employees: {
                male:
                  employees?.turnoverRate?.previousfy?.employees?.male ?? "",
                female:
                  employees?.turnoverRate?.previousfy?.employees?.female ?? "",
                total:
                  employees?.turnoverRate?.previousfy?.employees?.total ?? "",
              },
              workers: {
                male: employees?.turnoverRate?.previousfy?.workers?.male ?? "",
                female:
                  employees?.turnoverRate?.previousfy?.workers?.female ?? "",
                total:
                  employees?.turnoverRate?.previousfy?.workers?.total ?? "",
              },
            },
            priorfy: {
              employees: {
                male: employees?.turnoverRate?.priorfy?.employees?.male ?? "",
                female:
                  employees?.turnoverRate?.priorfy?.employees?.female ?? "",
                total: employees?.turnoverRate?.priorfy?.employees?.total ?? "",
              },
              workers: {
                male: employees?.turnoverRate?.priorfy?.workers?.male ?? "",
                female: employees?.turnoverRate?.priorfy?.workers?.female ?? "",
                total: employees?.turnoverRate?.priorfy?.workers?.total ?? "",
              },
            },
          },
          turnoverRateDoc: employees?.turnoverRateDoc || [],
          womenRepresentationDoc: employees?.womenRepresentationDoc || [],
          empAndworkerandifferentlyabledDoc:
            employees?.empAndworkerandifferentlyabledDoc || [],
        });
      })
      .catch((err) => {
        console.log(err, "fetching data");
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async () => {
    // e.preventDefault();
    if (!disabled) {
      try {
        if (validateFields(formValues, errorsindex)) return;
        // Send PUT request to the backend API
        const res = await put(`${api}/brsr/update?id=${id}`, {
          type: "SectionA",
          employeesAndWorkersSubmitted: true,
          employeesAndWorkers: { ...formValues },
        });

        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        onSave();
      } catch (error) {
        console.log(error);
        setsnackOpen({
          open: true,
          message: error.response?.data?.message || "An error occurred",
          severity: "error",
        });
      }
    } else onSave();
  };

  const heading = [
    {
      title: "Particulars",
    },
    {
      title: "Total Employees",
      key: "total",
    },
    {
      title: "Male(Number)",
      key: "male",
    },
    {
      title: "Male(%)",
      key: "malepercentage",
    },
    {
      title: "Female(Number)",
      key: "female",
    },
    {
      title: "Female(%)",
      key: "femalepercentage",
    },
  ];
  const Participation = [
    {
      title: "Particulars",
    },
    {
      title: "Total",
      key: "total",
    },
    {
      title: "Female(Number)",
      key: "female",
    },
    {
      title: "Female(%)",
      key: "femalepercentage",
    },
  ];
  const Trunover = [
    {
      title: "Particulars",
    },
    {
      title: "Male",
      key: "male",
    },
    {
      title: "Female",
      key: "female",
    },
    {
      title: "Total",
      key: "total",
    },
  ];

  const generateColumnValue = (title) => {
    if (title === "Employee") {
      return [
        { title: "Employee" },
        { value: "Permanent ", key: "emp.permanent" },
        { value: "Other than Permanent ", key: "emp.other" },
        { value: "Total Employees", key: "emp.total" },
      ];
    } else if (title === "Workers") {
      return [
        { title: "Workers" },
        { value: "Permanent", key: "worker.permanent" },
        { value: "Other than Permanent ", key: "worker.other" },
        { value: "Total Workers", key: "worker.total" },
      ];
    } else if (title === "DifferentlyEmployees") {
      return [
        { title: "DifferentlyEmployees" },
        { value: "Permanent ", key: "differentlyabled.employees.permanent" },
        {
          value: "Other than Permanent ",
          key: "differentlyabled.employees.other",
        },
        { value: "Total ", key: "differentlyabled.employees.total" },
      ];
    } else if (title === "DifferentlyWorkers") {
      return [
        { title: "DifferentlyWorkers" },
        { value: "Permanent ", key: "differentlyabled.workers.permanent" },
        {
          value: "Other than Permanent ",
          key: "differentlyabled.workers.other",
        },
        { value: "Total  Workers", key: "differentlyabled.workers.total" },
      ];
    } else if (title === "Women") {
      return [
        { title: "Women" },
        {
          value: "Board of Directors",
          key: "womenRepresentation.boardOfDirectors",
        },
        {
          value: "Key Mangement Personnel",
          key: "womenRepresentation.keyManagementPersonnel",
        },
      ];
    } else if (title === "currentTurnover") {
      return [
        { title: "currentTurnover" },
        {
          value: "Permanent Employees",
          key: "turnoverRate.currentfy.employees",
        },
        {
          value: "Permanent Workers",
          key: "turnoverRate.currentfy.workers",
        },
      ];
    } else if (title === "previousTrunOver") {
      return [
        { title: "previousTurnOver" },
        {
          value: "Permanent Employees",
          key: "turnoverRate.previousfy.employees",
        },
        {
          value: "Permanent Workers",
          key: "turnoverRate.previousfy.workers",
        },
      ];
    } else if (title === "priorTrunover") {
      return [
        { title: "priorTurnover" },
        { value: "Permanent Employees", key: "turnoverRate.priorfy.employees" },
        {
          value: "Permanent Workers",
          key: "turnoverRate.priorfy.workers",
        },
      ];
    }
  };

  return (
    <Box>
      <p className={style.subHeading}>IV. EMPLOYEES</p>
      <EmpTable
        heading={heading}
        columnWidth={"19% 18% 16% 16% 19% 12%"}
        // columnValue={columnValue}
        columnValue={generateColumnValue("Employee")}
        title={"Employee"}
        topHeading={"a. Employees and workers (including differently abled):"}
        topheader={"20.Details at the end of Financial Year"}
        formValues={formValues}
        setErrors={setErrors}
        setFormValues={setFormValues}
        setIndex={setErrorsIndex}
        errorsindex={errorsindex}
        errors={errors?.emp}
        disabled={disabled}
      />
      {/* <p> {errors?.emp?.map((item)=>item?.rowIndex)}</p> */}
      {/* {[...new Set(errors?.emp?.map((item) => item?.rowIndex))].join(", ")} */}
      <EmpTable
        heading={heading}
        columnWidth={"19% 18% 16% 16% 19% 12%"}
        columnValue={generateColumnValue("Workers")}
        title={"Workers"}
        formValues={formValues}
        setFormValues={setFormValues}
        setIndex={setErrorsIndex}
        setErrors={setErrors}
        errorsindex={errorsindex}
        errors={errors?.worker}
        disabled={disabled}
      />
      {/* {[...new Set(errors?.worker?.map((item) => item?.rowIndex))].join(", ")} */}
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <EmpTable
        heading={heading}
        columnWidth={"19% 18% 16% 16% 19% 12%"}
        columnValue={generateColumnValue("DifferentlyEmployees")}
        title={"Differently abled Employees"}
        topHeading={"b. Differently abled Employees and workers:"}
        formValues={formValues}
        setFormValues={setFormValues}
        setErrors={setErrors}
        setIndex={setErrorsIndex}
        disabled={disabled}
        errorsindex={errorsindex}
        errors={errors?.differentlyabled?.filter((item) =>
          `${item.subkey}`.includes("employees"),
        )}
      />
      {/* {[
        ...new Set(
          errors?.differentlyabled
            ?.filter((item) => `${item.fieldName}`.includes("employees")) // ✅ Filter only the required field
            ?.map((item) => item.rowIndex) // ✅ Extract rowIndex
        ),
      ].join(", ")} */}
      <EmpTable
        heading={heading}
        columnWidth={"19% 18% 16% 16% 19% 12%"}
        columnValue={generateColumnValue("DifferentlyWorkers")}
        title={"Differently abled Workers"}
        formValues={formValues}
        setFormValues={setFormValues}
        setErrors={setErrors}
        errorsindex={errorsindex}
        setIndex={setErrorsIndex}
        errors={errors?.differentlyabled?.filter((item) =>
          `${item.subkey}`.includes("workers"),
        )}
        disabled={disabled}
      />
      {/* <Box sx={{ mt: 1 }}>
        <Button
          variant="contained"
          sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
          onClick={(e) =>
            handleUploadDocument(e, "empAndworkerandifferentlyabledDoc")
          }
        >
          Upload Document <AddIcon sx={{ ml: 2 }} />
        </Button>
      </Box> */}
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formValues,
          setFormData: setFormValues,
          errors,
          setErrors,
          Uploadkey: "empAndworkerandifferentlyabledDoc",
          ml: 2.5,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <div className="a4-page">
        <EmpTable
          heading={Participation}
          columnWidth={"19% 30% 31% 20%"}
          columnValue={generateColumnValue("Women")}
          title={"21.Participation/Inclusion/Representation of Women"}
          formValues={formValues}
          setFormValues={setFormValues}
          setErrors={setErrors}
          errorsindex={errorsindex}
          setIndex={setErrorsIndex}
          errors={errors?.womenRepresentation}
          disabled={disabled}
        />
      </div>
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      {/* <Box sx={{ mt: 1 }}>
        <Button
          variant="contained"
          sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
          onClick={handleUploadDocument}
        >
          Upload Document <AddIcon sx={{ ml: 2 }} />
        </Button>
      </Box> */}
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formValues,
          setFormData: setFormValues,
          errors,
          setErrors,
          Uploadkey: "womenRepresentationDoc",
          ml: 2.5,
          removeUpload,
        }}
      />

      <EmpTable
        heading={Trunover}
        columnWidth={"21% 29% 30% 20%"}
        columnValue={generateColumnValue("currentTurnover")}
        title={`a.Turnover rate in current FY  (${
          currentyear - 1
        } - ${currentyear})`}
        topHeading={
          "22. Trunover rate for permanent employees and workers (Disclose trends for the past 3 years)"
        }
        formValues={formValues}
        setFormValues={setFormValues}
        setErrors={setErrors}
        errorsindex={errorsindex}
        setIndex={setErrorsIndex}
        errors={errors?.turnoverRate?.filter((item) =>
          `${item.subkey}`.includes("currentfy"),
        )}
        disabled={disabled}
      />
      {/* </div> */}
      {/* {[
        ...new Set(
          errors?.turnoverRate
            ?.filter((item) => `${item.fieldName}`.includes("Currentfy")) // ✅ Filter only the required field
            ?.map((item) => item.rowIndex) // ✅ Extract rowIndex
        ),
      ].join(", ")} */}
      <EmpTable
        heading={Trunover}
        columnWidth={"21% 29% 30% 20%"}
        columnValue={generateColumnValue("previousTrunOver")}
        title={`b.Turnover rate in previous FY  (${currentyear - 2}-${
          currentyear - 1
        })`}
        formValues={formValues}
        setFormValues={setFormValues}
        setIndex={setErrorsIndex}
        setErrors={setErrors}
        errorsindex={errorsindex}
        errors={errors?.turnoverRate?.filter((item) =>
          `${item.subkey}`.includes("previousfy"),
        )}
        disabled={disabled}
      />
      <EmpTable
        heading={Trunover}
        columnWidth={"21% 29% 30% 20%"}
        columnValue={generateColumnValue("priorTrunover")}
        title={`c.Turnover rate in the year prior to the previous FY  (${
          currentyear - 3
        }-${currentyear - 2})`}
        formValues={formValues}
        setFormValues={setFormValues}
        setIndex={setErrorsIndex}
        setErrors={setErrors}
        errorsindex={errorsindex}
        errors={errors?.turnoverRate?.filter((item) =>
          `${item.subkey}`.includes("priorfy"),
        )}
        disabled={disabled}
      />
      {/* <Box sx={{ mt: 1 }}>
        <Button
          variant="contained"
          sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
          onClick={handleUploadDocument}
        >
          Upload Document <AddIcon sx={{ ml: 2 }} />
        </Button>
      </Box> */}
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formValues,
          setFormData: setFormValues,
          errors,
          setErrors,
          Uploadkey: "turnoverRateDoc",
          ml: 2.5,
          removeUpload,
        }}
      />

      <Snackbar
        open={snackOpen.open}
        message={snackOpen.message} // Optional, since you're using <Alert> for the message
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity || "info"} // Ensure a default severity if undefined
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message || "No message provided"}
        </Alert>
      </Snackbar>
      {!hide && (
        <>
          {brsrReview ? (
            <Box sx={{ width: "98%", ml: 2 }}>
              <ReviewBox
                url={`/brsr/review/${id}`}
                handleSubmit={handleSubmit}
              />
            </Box>
          ) : (
            <Box textAlign="right" sx={{ mt: 3 }}>
              <Button
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
                onClick={handleSubmit}
              >
                Save & Continue <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default Employees;
